export enum UiStatus {
  NONE = "none",
  INITIALIZING = "initializing",
  ERROR = "error",
  CONNECTION_ERROR = "connection error",
  PRINTER_ERROR = "printer error",
  LOADING = "loading",
  PRINTING = "printing",
  IDLE = "idle",
  READY = "ready",
}
